/* sucrase/dist/esm/transformers/Transformer.js */ function _(require, module, exports, __esModule, __esExport) {
    __esModule();
    class Transformer {
        // Return true if anything was processed, false otherwise.
        getPrefixCode() {
            return "";
        }
        getHoistedCode() {
            return "";
        }
        getSuffixCode() {
            return "";
        }
    }
    exports.default = Transformer;
}
